import { Route } from '@angular/router';
import { hasAuthTypeOrRedirectGuard } from '@rma/dashboard/authentication/public/util-auth-redirect';
import { logRedirectNonLegacy, RmaEmptyComponent, stripProfileRedirectAngularGuard } from '@rma/dashboard/generic/util/router-utils';

export const officeRoutes: Route[] = [
  {
    path: 'agency',
    children: [
      {
        path: '',
        canActivate: [hasAuthTypeOrRedirectGuard('office')],
        children: [
          // Remove after 2024-06-30 hasPlatformAccess guard may of been the cause updated on (May 20th, 2025)
          {
            path: 'linked-accounts',
            canActivate: [stripProfileRedirectAngularGuard('/settings')],
            canActivateChild: [stripProfileRedirectAngularGuard('/settings')],
            children: [
              {
                path: '**',
                component: RmaEmptyComponent,
              },
            ],
          },
          // Remove after 2024-06-30 publish and manage was in public (resolved) (2025-06-06)
          {
            path: 'market-reports',
            canActivate: [stripProfileRedirectAngularGuard()],
            canActivateChild: [stripProfileRedirectAngularGuard()],
            children: [
              {
                path: '**',
                component: RmaEmptyComponent,
              },
            ],
          },
          // Remove after 2024-06-30 DC Common Url Provider DataFeed (resolved) (2025-06-06)
          {
            path: 'data-feeds',
            canActivate: [logRedirectNonLegacy('/settings/data-feeds')],
            component: RmaEmptyComponent,
          },
        ],
      },
      //unauthenticated
      // Remove after 2024-06-30
      {
        path: '',
        children: [
          {
            path: 'data-feeds/:code',
            canActivate: [stripProfileRedirectAngularGuard('/settings')],
            canActivateChild: [stripProfileRedirectAngularGuard('/settings')],
            children: [
              {
                path: '**',
                component: RmaEmptyComponent,
              },
            ],
          },
        ],
      },
    ],
  },
];
